import type { ReactNode } from 'react'
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'
import { Button } from '@components/atoms/Button'
import { Typography } from '@components/atoms/Typography'
import { errorHandler } from './errorHandler'
import styles from './AppErrorBoundary.module.scss'

function Fallback({ resetErrorBoundary }: FallbackProps) {
  return (
    <div className={styles.root} role="alert">
      <div className={styles.copy}>
        <Typography variant="title-md">Something went wrong</Typography>
        <Typography variant="body-md">
          The page hit an unexpected error. Try again, and if it keeps
          happening, reload the app.
        </Typography>
      </div>
      <Button type="primary" onClick={resetErrorBoundary}>
        Try again
      </Button>
    </div>
  )
}

/** App-root boundary. Catches uncaught render errors, shows a fallback, and
 * (dev-only) posts them to the server via {@link errorHandler}. */
export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={errorHandler}>
      {children}
    </ErrorBoundary>
  )
}
